export default {
  namespaced: true,
  state: {
    offer: null,
    status: null,
    credentialId: null,
    component: null,
    tempOfferStatus: null
  },
  getters: {
    getOffer(state) {
      return state.offer
    },
    getStatus(state) {
      return state.status
    },
    getCredentialId(state) {
      return state.credentialId
    },
    getCurrentComponent(state) {
      return state.component
    },
    getTempOfferStatus(state) {
      return state.tempOfferStatus
    }
  },
  mutations: {
    setOffer(state, offer) {
      state.offer = offer
    },
    setStatus(state, status) {
      state.status = status
    },
    setCredentialId(state, credentialId) {
      state.credentialId = credentialId
    },
    setCurrentComponent(state, component) {
      state.component = component
    },
    setTempOfferStatus(state, tempOfferStatus) {
      state.tempOfferStatus = tempOfferStatus
    }
  },
  actions: {
    setOffer({ commit }, offer) {
      commit('setOffer', offer)
    },
    setStatus({ commit }, status) {
      commit('setStatus', status)
    },
    setCredentialId({ commit }, credentialId) {
      commit('setCredentialId', credentialId)
    },
    setCurrentComponent({ commit }, component) {
      commit('setCurrentComponent', component)
    },
    setTempOfferStatus({ commit }, tempOfferStatus) {
      commit('setTempOfferStatus', tempOfferStatus)
    }
  }
}
